import React from 'react'
import { useTranslation } from 'react-i18next'

import { roundNumber } from '@/utils'
import nutritionFactsList from './nutritionFactsList'
import NutritionFactsGroup from './NutritionFactsGroup'
import { NutritionalValueFields } from './NutritionValueCalculator'

import './NutritionFacts.css'

type Props = {
  nutritionalValue: NutritionalValueFields
  decimalPlaces?: number
}
function NutritionFacts({ nutritionalValue, decimalPlaces = 0 }: Props) {
  const { t } = useTranslation()

  return (
    <div className="NutritionFacts">
      <h3 className="NutritionFacts-header">{t('nutrition.nutritionFacts')}</h3>

      <div className="NutritionFacts-energy">
        <div className="NutritionFacts-energyLabel">
          <div>{t('nutrition.perServing')}</div>
          <div className="NutritionFacts-energyCalories">{t('nutrition.calories')}</div>
        </div>
        <div className="NutritionFacts-energyValue">
          {roundNumber(nutritionalValue.energy, decimalPlaces)}
        </div>
      </div>

      {nutritionFactsList.map((group) => (
        <NutritionFactsGroup key={group.name} nutritionalValue={nutritionalValue} group={group} />
      ))}
    </div>
  )
}

export default React.memo(NutritionFacts)
